module.exports = "/* eslint-disable */\n\nvar $tabs = $('.tabs .tab');\n\n$tabs.click(function(event) {\n  var selectedClass = 'is-tab-selected';\n  $tabs.removeClass(selectedClass);\n  $(event.target).addClass(selectedClass);\n});\n"


//////////////////
// WEBPACK FOOTER
// /Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/raw-loader!./ui/views/demos/tabs.js
// module id = 790
// module chunks = 0